/**
 * Overlay stacking (high → low among peers by intent):
 * tours 10050+, notifications 10050, floating menus 10000, chat drawer 9999,
 * confirm modals 1300, modals 1200, app header 1000.
 */
export const MODAL_Z_INDEX = 1200;
/** Selects, menus, and date popovers above modals/drawers. */
export const FLOATING_Z_INDEX = 10000;
/** Toasts above modals/drawers so feedback stays visible while popups are open. */
export const NOTIFICATIONS_Z_INDEX = 10050;
